export const SuprimentosEstoque = {
    // Letra A:
    AJUSTE_INVENTARIO: 'Inventory adjustment',
    AJUSTE_INVENTARIO_AVISO_SEM_CUSTO: 'Product has no cost in this depot: enter the unit value of the surplus.',
    AJUSTE_INVENTARIO_SEM_DIFERENCA: 'The counted quantity is equal to the stock quantity.',
    AJUSTE_INVENTARIO_SUCESSO: 'Inventory adjustment completed successfully!',

    // Letra B:
    // Letra C:
    CONFIRMAR_AJUSTE_INVENTARIO: 'Confirm adjustment',

    // Letra D:
    DIFERENCA_INVENTARIO: 'Difference (counted - system)',
    DATA_AJUSTE: 'Adjustment date',

    // Letra E:
    // Letra F:
    // Letra G:
    // Letra H:
    // Letra I:
    // Letra J:
    // Letra K:
    // Letra L:
    // Letra M:
    MOTIVO_AJUSTE: 'Adjustment reason',

    // Letra N:
    // Letra O:
    // Letra P:
    // Letra Q:
    QUANTIDADE_CONTADA: 'Counted quantity',
    QUANTIDADE_SISTEMA: 'System quantity',

    // Letra R:
    // Letra S:
    // Letra T:
    // Letra U:
    // Letra V:
    VALOR_UNITARIO_SOBRA: 'Unit value',

    // Letra X:
    // Letra Y:
    // Letra Z:
}
